module.exports = __webpack_public_path__ + "vc.svg?1ee6703b8f93ab9550ae60ca5aed6948";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/vc.svg
// module id = 970
// module chunks = 27